import React from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import { useEffect, useRef } from 'react';

const ProjectAnimation = () => {
  const theme = useTheme();
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref);
  
  // Project-related icons with more variety
  const icons = [
    { emoji: '💻', delay: 0 },
    { emoji: '🚀', delay: 0.2 },
    { emoji: '⚛️', delay: 0.4 },
    { emoji: '🎨', delay: 0.6 },
    { emoji: '📱', delay: 0.8 },
    { emoji: '🤖', delay: 1 },
    { emoji: '🔥', delay: 1.2 },
    { emoji: '⚡', delay: 1.4 },
    { emoji: '🌟', delay: 1.6 },
    { emoji: '🎮', delay: 1.8 }
  ];

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };

  const iconVariants = {
    hidden: { 
      opacity: 0,
      y: 20,
      scale: 0.5
    },
    visible: (delay) => ({
      opacity: [0, 1],
      y: [20, 0],
      scale: [0.5, 1],
      transition: {
        delay: delay,
        duration: 0.5,
        ease: "easeOut"
      }
    }),
    floating: (delay) => ({
      y: [0, -15, 0],
      scale: [1, 1.1, 1],
      transition: {
        delay: delay,
        duration: 3,
        ease: "easeInOut",
        repeat: Infinity,
        repeatType: "reverse"
      }
    })
  };

  return (
    <motion.div
      ref={ref}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
        zIndex: 0
      }}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={controls}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '40px',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '600px',
          padding: '20px'
        }}
      >
        {icons.map((icon, index) => (
          <motion.div
            key={index}
            custom={icon.delay}
            variants={iconVariants}
            initial="hidden"
            animate={["visible", "floating"]}
            style={{
              fontSize: '2.5rem',
              color: theme.palette.mode === 'dark' 
                ? 'rgba(255, 255, 255, 0.8)' 
                : 'rgba(0, 0, 0, 0.8)',
              textShadow: theme.palette.mode === 'dark'
                ? '0 0 15px rgba(255, 255, 255, 0.4)'
                : '0 0 15px rgba(0, 0, 0, 0.2)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '60px',
              height: '60px'
            }}
          >
            {icon.emoji}
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ProjectAnimation; 